var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 60,
    viewBox: "0 0 91 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 90,
    height: 60,
    rx: 2,
    fill: "white",
    fillOpacity: 0.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7383,
    y: 11.3477,
    width: 19.7507,
    height: 11.8504,
    rx: 1.58006,
    fill: "#616161"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7383,
    y: 24.7773,
    width: 19.7507,
    height: 11.8504,
    rx: 1.58006,
    fill: "#616161"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7383,
    y: 38.209,
    width: 19.7507,
    height: 11.8504,
    rx: 1.58006,
    fill: "#616161"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.4082,
    y: 11.3477,
    width: 19.7507,
    height: 11.8504,
    rx: 1.58006,
    fill: "#616161"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 3.4082,
    y: 24.7773,
    width: 19.7507,
    height: 11.8504,
    rx: 1.58006,
    fill: "#616161"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.4082,
    y: 38.209,
    width: 19.7507,
    height: 11.8504,
    rx: 1.58006,
    fill: "#616161"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 46.0684,
    y: 11.3477,
    width: 19.7507,
    height: 11.8504,
    rx: 1.58006,
    fill: "#616161"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 46.0684,
    y: 24.7773,
    width: 19.7507,
    height: 11.8504,
    rx: 1.58006,
    fill: "#616161"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 46.0684,
    y: 38.209,
    width: 19.7507,
    height: 11.8504,
    rx: 1.58006,
    fill: "#616161"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 67.4004,
    y: 11.3477,
    width: 19.7507,
    height: 11.8504,
    rx: 1.58006,
    fill: "#616161"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 67.4004,
    y: 24.7773,
    width: 19.7507,
    height: 11.8504,
    rx: 1.58006,
    fill: "#616161"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 67.4004,
    y: 38.209,
    width: 19.7507,
    height: 11.8504,
    rx: 1.58006,
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid01);
export default __webpack_public_path__ + "static/media/grid_01.f06e6d5748a63453298dd0f7b8419550.svg";
export { ForwardRef as ReactComponent };